import MuiModal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import CloseIcon from '@mui/icons-material/Close';
import StarRateRoundedIcon from '@mui/icons-material/StarRateRounded';
import StarOutlineRoundedIcon from '@mui/icons-material/StarOutlineRounded';
import GoogleIconSvg from '../../../images/google_icon.svg';
import { ModalWrapper, ModalContent, StarsRow, Rating } from './styled';

interface RecommendationModalUIProps {
  open: boolean;
  reviewUrl: string;
  onReview: () => void;
  onMaybeLater: () => void;
  onClose: () => void;
}

const RecommendationModalUI = ({ open, reviewUrl, onReview, onMaybeLater, onClose }: RecommendationModalUIProps) => (
  <MuiModal open={open} onClose={onClose}>
    <ModalWrapper>
      <ModalContent>
        <CloseIcon
          onClick={onClose}
          sx={{ position: 'absolute', top: 16, right: 16, cursor: 'pointer', color: 'brand.darkGreen' }}
        />

        <Typography variant="h2" sx={{ mb: 2 }}>
          O que achou da Oya?
        </Typography>

        <Typography variant="body1">
          Seu relato pode acolher outras mulheres que estão buscando o mesmo cuidado que você encontrou aqui. Ao compartilhar
          sua experiência, você as ajuda a escolher com mais segurança.
        </Typography>

        <StarsRow>
          <a
            href={reviewUrl || undefined}
            target="_blank"
            onClick={onReview}
            rel="noopener noreferrer"
            style={{ lineHeight: 0 }}
          >
            <Rating
              name="recommendation-rating"
              value={null}
              onChange={(_, v) => v !== null && onReview()}
              emptyIcon={<StarOutlineRoundedIcon fontSize="large" />}
              icon={<StarRateRoundedIcon fontSize="large" />}
              size="large"
            />
          </a>
        </StarsRow>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, width: '100%' }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<img src={GoogleIconSvg} alt="" width={18} height={18} />}
            href={reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            component="a"
            onClick={onReview}
            sx={{ width: 'fit-content' }}
          >
            Review no Google
          </Button>

          <Link
            component="button"
            variant="body1"
            onClick={onMaybeLater}
            sx={{ cursor: 'pointer', color: 'brand.darkGreen' }}
          >
            Talvez depois
          </Link>
        </Box>
      </ModalContent>
    </ModalWrapper>
  </MuiModal>
);

export default RecommendationModalUI;
